<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import TeamSelector from '../TeamSelector.vue';
import { useVuelidate } from '@vuelidate/core';
import branchesAPI from 'dashboard/api/branches';

export default {
  components: {
    PageHeader,
    TeamSelector,
  },
  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      selectedTeams: [],
      isCreating: false,
    };
  },

  computed: {
    ...mapGetters({
      teamList: 'teams/getTeams',
    }),

    branchId() {
      return this.$route.params.branchId;
    },
    headerTitle() {
      return this.$t('BRANCHES_SETTINGS.TEAMS.ADD_TITLE', {
        branchName: this.currentBranch?.name || '',
      });
    },
    currentBranch() {
      return this.$store.getters['branches/getBranch'](this.branchId);
    },
  },

  mounted() {
    this.$store.dispatch('teams/get');
  },

  methods: {
    updateSelectedTeams(newTeamList) {
      this.selectedTeams = [...newTeamList];
    },
    async addTeams() {
      this.isCreating = true;
      const { branchId, selectedTeams } = this;

      try {
        await branchesAPI.updateTeams({
          branchId,
          teamsList: selectedTeams,
        });
        router.replace({
          name: 'settings_branches_finish',
          params: {
            page: 'new',
            branchId,
          },
        });
        this.$store.dispatch('branches/get');
        this.$store.dispatch('teams/get'); // Refresh teams to get updated branch_id
      } catch (error) {
        useAlert(error.message);
      }
      this.isCreating = false;
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-8 col-span-6 overflow-auto">
    <form class="flex flex-col gap-4 mx-0" @submit.prevent="addTeams">
      <PageHeader
        :header-title="headerTitle"
        :header-content="$t('BRANCHES_SETTINGS.TEAMS.HEADER_CONTENT')"
      />

      <div class="w-full h-full">
        <TeamSelector
          :team-list="teamList"
          :selected-teams="selectedTeams"
          :current-branch-id="branchId"
          :update-selected-teams="updateSelectedTeams"
          :is-working="isCreating"
          :submit-button-text="$t('BRANCHES_SETTINGS.TEAMS.ADD_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
